export default __webpack_public_path__ + "static/media/falafel.57519182.svg";